require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-walkingthetightrope.json") })
        }
      }, "path---insights-walkingthetightrope");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-walkingthetightrope!./.cache/json/insights-walkingthetightrope.json
// module id = 1142
// module chunks = 231608221292675